export default __webpack_public_path__ + "static/captureFeatureHome-a5fa9e01191c1dd72b83be666621412b.svg";